import { combineReducers } from 'redux';
import formReducer from './formReducer';
import shortFormReducer from './shortFormReducer';

const rootReducer = combineReducers({
  formData: formReducer,
  shortFormData: shortFormReducer,
});

export default rootReducer;
